import './App.css';
import TicTacToe from './components/tictactoe/TicTacToe';

function App() {
  return (
    <div>
      <TicTacToe />
    </div>
  );
}

export default App;
